import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import Breadcrumbs from '@Components/Breadcrumbs';
import { useFlowCategories } from '@Hooks/useFlowCategories';
import { useEffect } from 'react';
import FlowCategoryCard from '@Components/FlowCategoryCard';

export default function FlowCategoryCards() {
  const {
    data: flowCategories,
    isError,
    error,
  } = useFlowCategories({
    searchParams: {
      include: 'flows',
    },
  });

  useEffect(() => {
    if (isError && error) {
      toastError(
        error instanceof Error
          ? error.message
          : 'Failed to load Flow Categories',
      );
    }
  }, [isError, error]);

  return (
    <div className="h-full w-full">
      <Breadcrumbs
        navList={[
          { name: 'Flows', href: '/flows' },
          { name: 'Cards', href: '/flows/cards' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Flow Categories</Heading>
          <p>View Flow Categories within your organization.</p>
        </div>
      </div>
      <div className="grid min-w-300 grid-cols-4 gap-6 overflow-auto">
        {flowCategories?.data?.length &&
          flowCategories.data.map((category) => {
            return <FlowCategoryCard key={category.id} category={category} />;
          })}
      </div>
    </div>
  );
}
